import { showErrorDialog } from 'v3/data/store/error/actions';
import { setProductMaxPercentage } from 'v3/data/store/product/actions';
import { showSnackbar } from 'v3/data/store/snackbar/actions';
import { updateSkuMaxPercentage } from 'v3/services/api';

export const changeProductMaxPercentage = async (
  skuId: string,
  data: { maxPercentage: number; maxPercentageAccessories: number; maxPercentageInsurance: number },
): Promise<void> => {
  const { maxPercentage, maxPercentageAccessories, maxPercentageInsurance } = data;
  try {
    await updateSkuMaxPercentage(skuId, { maxPercentage, maxPercentageAccessories, maxPercentageInsurance });
    setProductMaxPercentage({ id: skuId, maxPercentage, maxPercentageAccessories, maxPercentageInsurance });
    showSnackbar('A porcentagem máxima foi atualizada com sucesso', 'success', true);
  } catch (error) {
    showErrorDialog('Erro ao atualizar as porcentagens máximas do produto.', error);
  }
};
